export enum TestTypeTest {
  NETWORK_QUALITY = 'network-quality',
  SERVICE_CONTINUITY = 'service-continuity',
  VOIP = 'voip',
  TRUESPEED = 'truespeed'
}
export enum WarningMessage {
  NETWORK_WARNING_MESSAGE = 'Test will be queued/failed.All network test resources are currently in use',
  SERVICE_WARNING_MESSAGE = 'Test will be queued/failed.All service test resources are currently in use',
  VOIP_WARNING_MESSAGE = 'Test will be queued/failed.All voip test resources are currently in use',
  TRUESPEED_WARNING_MESSAGE = 'Test will be queued/failed.All truespeed test resources are currently in use',
  RESOURCE_AVAILABLE_WARNING_MESSAGE = 'Resources Available. Ready for test',
  ALL_TEST_WARNING_MESSAGE = 'Test will be queued/failed.All test resources are in use'
}
export type TestType = 'NQ' | 'SC' | 'VoIP' | 'Truespeed' | 'multistep' | '';
export type Status = 'none' | 'good' | 'warning' | 'critical';
export type OperationalState =
  | 'stopped'
  | 'running'
  | 'failed'
  | 'queued'
  | 'unknown'
  | 'finished'
  | 'scheduled';
export type AdministrativeState = 'Enabled' | 'Disabled';
export type RunType = 'on-demand' | 'on-going' | '';
export type State = 'enabled' | 'destroyed' | 'disabled';
export type Platform = 'VMDK' | 'QCOW2' | 'WINDOWS' | 'OVA' | 'OLHW';
export interface ICoordinates {
  lat: number;
  lon: number;
}

export enum TEST_STATE {
  RUNNING = 'running',
  QUEUED = 'queued',
  STOPPED = 'stopped',
  FINISHED = 'finished',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
  ABORTED = 'aborted'
}

export enum TestTypeValue {
  NETWORK_QUALITY = 'NQ',
  SERVICE_CONTINUITY = 'SC',
  VOIP = 'VoIP',
  TRUESPEED = 'Truespeed',
  MULTISTEP = 'multistep'
}

export interface IMetaDataItem {
  key: string;
  value: string;
}

export interface IService {} //eslint-disable-line

export interface IAgentSelector {
  regionName: string;
  id: string;
  alias: string;
  location: {
    name: string;
    url?: string;
    coordinate?: {
      lat: number;
      lon: number;
    };
  };
  bbox: [number, number, number, number];
  visible: boolean;
  isCloudAgent: boolean;
}

export interface IMonitor {
  id: string;
  alias: string;
  agentSelector: IAgentSelector;
  service: {
    id: string;
    label: string;
    icon: string;
    agentSelector: IAgentSelector;
    url: string;
    phonenumber?: string;
  };
  dateCreated: number;
  operationalState: OperationalState;
  operationalStateMessage: string;
  administrativeState: AdministrativeState;
  runType: RunType;
  testType:
    | 'network-quality'
    | 'service-continuity'
    | 'voip'
    | 'truespeed'
    | 'y1564'
    | 'multistep'
    | 'udp'
    | 'http'
    | 'bert'
    | '';
  metaData: Array<IMetaDataItem>;
  agentId?: string;
  tests?: ITest;
  failingKpis?: Array<IFailingKpi>;
  lastTest?: ITest;
  lastGoodTest?: ITest;
  status?: Status;
  originatorSite: string;
  destinationSite?: string;
  labels?: string[];
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  testConfig?: any;
}

export interface ITest {
  availability: number;
  availabilityRowsCount: number;
  id: string;
  results: {
    timestamp: number;
    value: number;
  };
  sequenceId: number;
  status: Status;
  type: TestType;
}

export interface IFailingKpi {
  criticalThresholdValue: number;
  kpiName: string;
  state: Status;
  timestamp: number;
  units: string;
  value: number;
  warningThresholdValue: number;
}

export interface IPLocation {
  status: Status;
  state: Status;
  city: string;
  coordinate: {
    lon: number;
    lat: number;
  };
}

export interface INotificationResult {
  timeInMilliSec: number;
  description: string;
  source: ISource;
}

export interface ISource {
  sourceType: string;
  id: string;
  name: string;
}

export interface INotificationData {
  timestamp: number;
  formatedTimestamp: string;
  description: string;
  sourceName: string;
}

export interface ILogParams {
  source: string;
  monitorId: number;
  monitorName: string;
}
export interface ITestQueueStatus {
  network: ITestQueueCount;
  voip: ITestQueueCount;
  service: ITestQueueCount;
  truespeed?: ITestQueueCount;
  maxCount: number;
  overall_percentage: number;
  overall_total_used: number;
}

export interface ITestQueueCount {
  total: number;
  used: number;
  percentage?: number;
}
export interface ITestConfig {
  testType: string;
  capabilities: string;
  maxconcurrent: string;
  operationalState: string;
  testQueueStatusName: string;
  defaultMaxConcurrent?: number;
}

// a list of filter keywords used in existing filters
// or when configuring advanced-search
export enum FILTER_KEYS {
  SITE = 'site',
  APP = 'app',
  DEVICE = 'device',
  STATUS = 'status',
  TEST_TYPE = 'testtype',
  TEST_NAME = 'monitor'
}
